"use client";

import { getDetailOrder, getReportShopping } from "@/functions/databaseData";
import currency from "@/functions/currency";
import useModal from "@/functions/useModal";
import {
  CalendarOutlineSvg,
  CloseOutlineSvg,
  RemoveSvg,
  SearchSvg,
} from "@/public/svg";
import { format, formatDistanceToNow } from "date-fns";
import { id } from "date-fns/locale";
import { useCallback, useEffect, useMemo, useState } from "react";
import { BelanjaSaya, LaporanBelanjaJaringan } from "./_component";
import Input from "@/components/atom/Input";
import Button from "@/components/atom/Button";
import ContainerModal from "@/components/sub-atom/ContainerModal";
import Label from "@/components/sub-atom/Label";
import Divider from "@/components/atom/Divider";
import useHeader from "@/functions/useHeader";
import { cn } from "@/lib/utils";

const dateNow = new Date();
const year = dateNow.getFullYear();
const month = dateNow.getMonth();
const day = dateNow.getDate();

const title = {
  expired: "expired",
  canceled: "canceled",
  booking: "booking",
  ["konfirmasi-order"]: "konfirmasi order",
  ["on-process"]: "process",
  ["on-packing"]: "packing",
  ["on-delivery"]: "On-Delivery",
  received: "received",
  completed: "completed",

  // type payment
  paylater: "paylater",
  payment_gateway: "Via Online",
  COD: "cash on delivery",
  cash: "cash",

  // status pembayaran
  pending: "PENDING",
  paid: "PAID",
};

const colors = {
  expired: "orange",
  canceled: "errorGON",
  booking: "warningGON",
  ["konfirmasi-order"]: "teal",
  ["on-process"]: "teal",
  ["on-packing"]: "cyan",
  ["on-delivery"]: "secondaryGON",
  received: "successGON",
  completed: "primaryGON",

  // type payment
  paylater: "secondary",
  payment_gateway: "primary",
  COD: "greyscale",
  cash: "warning",

  // status pembayaran
  pending: "cyan",
  paid: "successGON",
};

export default function LaporanBelanja() {
  const { session } = useHeader();
  const { openModal, closeModal } = useModal();
  const [showAllOrder, setShowAllOrder] = useState(false);
  const [dataDetail, setDataDetail] = useState({});
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState({});
  const [date, setDate] = useState({
    date_from: "",
    date_until: "",
  });

  const [dataReport, setDataReport] = useState({});
  const [trigger, setTrigger] = useState(false);

  useEffect(() => {
    if (session) {
      runGetListOrder();
    }
  }, [session.user, trigger]);

  const runGetListOrder = useCallback(async () => {
    setLoading(true);
    try {
      let payload = {
        date_from: `${date?.date_from?.replaceAll("/", "-")}`,
        date_until: `${date?.date_until?.replaceAll("/", "-")}`,
      };

      const resDataReport = await getReportShopping({
        token: session?.user?.token,
        ...payload,
      });
      setDataReport(resDataReport);
      setTrigger(false);
    } catch (error) {
      console.log(error?.message);
    } finally {
      setLoading(false);
    }
  }, [session.user, trigger]);

  async function runGetDetailOrder(item) {
    try {
      const res = await getDetailOrder({
        mitra_id: item?.mitra_id,
        order_id: item?.order_id,
        token: session?.user?.token,
      });
      setDataDetail({
        ...res,
        products: res?.products?.sort(
          (a, b) =>
            (!a.product_canceled ? -1 : 1) - (!b.product_canceled ? -1 : 1)
        ),
      });
      console.log(res);
      openModal();
    } catch (error) {
      console.log(error.message);
    }
  }

  let maxDateRangeFrom = new Date();
  let maxDateRangeUntil = !date.date_from
    ? new Date()
    : new Date(date.date_from);
  maxDateRangeUntil.setDate(maxDateRangeUntil.getDate() + 14);

  return (
    <div className='flex flex-col gap-4 xs:gap-8'>
      <div className='flex flex-col md:flex-row justify-between items-end bg-shadesGON-50 shadow-normalGON rounded-2xl p-4 xs:p-8 gap-3 xs:gap-6'>
        <Input
          label={"Search"}
          icon={{
            left: (props) => <SearchSvg {...props} />,
          }}
          placeholder='contoh : GON238'
          onChange={(val) => setSearch(val?.replaceAll("#", ""))}
          value={search}
          onSubmit={(e) => e.preventDefault()}
          enterKeyHint={"search"}
        />
        <div
          className='w-full md:w-[80%] gap-4
          flex flex-col xs:flex-row items-center'>
          <Input
            label={"Dari Tanggal"}
            type='date'
            placeholder='dd/mm/yyyy'
            rangeDate={{
              max: maxDateRangeFrom.toISOString().split("T")[0],
            }}
            value={date.date_from}
            onSubmit={(e) => e.preventDefault()}
            onChange={(val) => {
              setDate((old) => ({ ...old, date_from: val }));
            }}
          />
          <Input
            label={"Sampai Tanggal"}
            type='date'
            placeholder='dd/mm/yyyy'
            rangeDate={{
              min: date.date_from,
              max: maxDateRangeUntil.toISOString().split("T")[0],
            }}
            value={date.date_until}
            onSubmit={(e) => e.preventDefault()}
            onChange={(val) => {
              setDate((old) => ({ ...old, date_until: val }));
            }}
          />
        </div>
        <div className='w-full md:w-auto flex gap-2 flex-col xs:flex-row'>
          {!date.date_from && !date.date_until ? null : (
            <Button
              className='flex w-full'
              label='reset'
              variants='outline'
              onClick={() => {
                setDate({ date_from: "", date_until: "" });
                setTrigger(true);
              }}
            />
          )}
          <Button
            className='flex w-full  md:w-auto'
            label='Tampilkan'
            disable={loading || !date?.date_from || !date?.date_until}
            loading={loading}
            onClick={() => {
              setTrigger(true);
            }}
          />
        </div>
      </div>
      <BelanjaSaya
        openModal={openModal}
        runGetDetailOrder={runGetDetailOrder}
        datas={dataReport?.transaction_mitra}
        dataReport={dataReport}
        session={session}
        search={search}
      />
      <LaporanBelanjaJaringan
        datas={dataReport?.transaction_downline_mitra}
        runGetDetailOrder={runGetDetailOrder}
        date={date}
        user={session?.user}
        range_date={dataReport?.range_date}
      />

      <ContainerModal className={"p-8"}>
        <div className='flex flex-col gap-10'>
          <div className='flex justify-between items-center'>
            <p className='subheading-semiBold text-greyscaleGON-700'>
              Detail Laporan Belanja{" "}
            </p>
            <div
              className='cursor-pointer'
              onClick={() => {
                closeModal();
                setShowAllOrder(false);
              }}>
              <RemoveSvg className='h-8 w-8 text-greyscaleGON-700' />
            </div>
          </div>
          <div className='flex flex-col sm:flex-row justify-between sm:items-center'>
            <p className='h4-semiBold text-primaryGON-400 max-w-full whitespace-nowrap overflow-hidden text-ellipsis'>
              #{dataDetail?.code_order}
            </p>
            <div className='flex flex-col gap-2 justify-end'>
              <p className='p1-regular text-greyscaleGON-400 sm:text-end'>
                Tanggal Transaksi
              </p>
              <p className='p1-medium text-greyscaleGON-700 sm:text-end'>
                {!dataDetail?.tanggal_checkout
                  ? dataDetail?.tanggal_checkout
                  : format(
                      new Date(dataDetail?.tanggal_checkout),
                      "dd MMMM yyyy"
                    )}
              </p>
            </div>
          </div>
          <div className='flex flex-col md:flex-row gap-4 w-full'>
            {/* Daftar Belanja */}
            <div className='w-full h-fit flex flex-col gap-8 py-8 border border-greyscaleGON-200 rounded-2xl'>
              <div className='flex justify-between items-center px-8'>
                <p className='subheading-semiBold text-greyscaleGON-400'>
                  Daftar Belanja
                </p>
                <p
                  className={cn(
                    "p3-regular  cursor-pointer",
                    dataDetail?.products?.reverse()?.length <= 2
                      ? "text-greyscaleGON-400"
                      : "text-primaryGON-400 hover:underline"
                  )}
                  onClick={() =>
                    dataDetail?.products?.reverse()?.length > 2 &&
                    setShowAllOrder(!showAllOrder)
                  }>
                  {dataDetail?.products?.reverse()?.length <= 2
                    ? ""
                    : !showAllOrder
                    ? "Tampilkan Semua"
                    : "Ciutkan"}
                </p>
              </div>
              <div
                className={cn(
                  "flex flex-col gap-4 px-8",
                  !showAllOrder
                    ? "max-h-60 overflow-hidden overflow-y-scroll"
                    : ""
                )}>
                {dataDetail?.products?.map((item, index) => (
                  <div
                    key={index}
                    className='flex justify-between items-end relative'>
                    {item?.product_canceled && (
                      <div className='absolute right-0 top-0'>
                        <Label
                          title={"Canceled"}
                          colors='error'
                          size='small'
                        />
                      </div>
                    )}
                    <div className='flex flex-col gap-2'>
                      <div className='flex xs:flex-row flex-col xs:items-center gap-2'>
                        <p className='p1-semiBold text-primaryGON-400 '>
                          {item?.name_product} : {item?.color}, {item?.size}
                        </p>
                        <Label
                          classNameText={
                            "max-w-full whitespace-nowrap overflow-hidden text-ellipsis"
                          }
                          size='small'
                          title={item?.brand}
                          colors='greyscale'
                        />
                      </div>
                      <div className='flex items-center gap-2'>
                        <div className='flex items-center gap-2'>
                          <p className='p1-regular text-greyscaleGON-700'>
                            {item?.qty}
                          </p>
                          <p className='p1-regular text-greyscaleGON-700'>x</p>
                          <p className='p1-regular text-greyscaleGON-700'>
                            {currency(
                              (item?.diskon_presentase || 0) > 0
                                ? ((100 - (item?.diskon_presentase || 0)) / 100) *
                                    item?.price_tags
                                : item?.price_tags - (item?.diskon_nominal || 0) > 0
                                ? item?.price_tags - (item?.diskon_nominal || 0)
                                : 0
                            )}
                          </p>
                        </div>
                        {((item?.diskon_presentase || 0) > 0 ||
                          (item?.diskon_nominal || 0) > 0) && (
                          <>
                            <p className='p1-regular text-greyscaleGON-400 line-through'>
                              {currency(item?.price_tags)}
                            </p>
                            {(item?.diskon_presentase || 0) > 0 && (
                              <Label
                                size='small'
                                title={`${(item?.diskon_presentase || 0)} %`}
                                colors='secondary'
                              />
                            )}
                          </>
                        )}
                      </div>
                    </div>
                    <p className='p1-semiBold text-greyscaleGON-700'>
                      {currency(
                        (item?.diskon_presentase || 0) > 0
                          ? ((100 - (item?.diskon_presentase || 0)) / 100) *
                              item?.price_tags *
                              item?.qty
                          : (item?.price_tags - (item?.diskon_nominal || 0)) *
                              item?.qty
                      )}
                    </p>
                  </div>
                ))}
              </div>
              <Divider />
              <div className='flex flex-col gap-4 px-8'>
                <div className='flex flex-col gap-2'>
                  {/* Sub Harga Produk */}
                  <div className='flex justify-between items-center '>
                    <p className='p1-regular text-greyscaleGON-400'>
                      Sub Harga Produk
                    </p>
                    <p className='p1-regular text-greyscaleGON-700'>
                      {currency(dataDetail?.total_harga_normal)}
                    </p>
                  </div>

                  {/* Total Diskon */}
                  <div className='flex justify-between items-center '>
                    <p className='p1-regular text-greyscaleGON-400'>
                      Total Diskon
                    </p>
                    <p className='p1-regular text-errorGON-400'>
                      -{" "}
                      {currency(
                        dataDetail?.total_diskon_presentase +
                          dataDetail?.total_diskon_nominal
                      )}
                    </p>
                  </div>

                  {/* total_voucher */}
                  <div className='flex justify-between items-center '>
                    <p className='p1-regular text-greyscaleGON-400'>
                      Total Voucher
                    </p>
                    <p className='p1-regular text-errorGON-400'>
                      -{currency(dataDetail?.total_voucher)}
                    </p>
                  </div>

                  {/* fee_admin */}
                  <div className='flex justify-between items-center '>
                    <p className='p1-regular text-greyscaleGON-400'>
                      Biaya Admin
                    </p>
                    <p className='p1-regular text-greyscaleGON-700'>
                      {currency(dataDetail?.admin_fee)}
                    </p>
                  </div>

                  {/* Sub Total Produk */}
                  <div className='flex justify-between items-center '>
                    <p className='p1-regular text-greyscaleGON-400'>
                      Sub Total Produk
                    </p>
                    <p className='p1-semiBold text-greyscaleGON-700'>
                      {currency(
                        dataDetail?.total_pembayaran -
                          dataDetail?.biaya_pengiriman
                      )}
                    </p>
                  </div>
                </div>
                <div className='flex flex-col gap-2'>
                  {/* Biaya Pengiriman */}
                  <div className='flex justify-between items-center '>
                    <p className='p1-regular text-greyscaleGON-400'>
                      Biaya Pengiriman ({dataDetail?.total_weight ?? "0"} gr)
                    </p>
                    <p className='p1-regular text-greyscaleGON-700'>
                      {currency(dataDetail?.biaya_pengiriman)}
                    </p>
                  </div>

                  {/* Biaya Pengiriman */}
                  <div className='flex flex-col gap-3 '>
                    <p className='p1-regular text-greyscaleGON-400'>
                      {dataDetail?.kurir?.provider} {dataDetail?.kurir?.layanan}
                    </p>
                    <div className='flex gap-1'>
                      <Label
                        title={dataDetail?.resi}
                        colors='greyscale'
                        size='small'
                      />
                      {/* <Button
                            label='Lacak'
                            variants='text'
                            size='small'
                            disable={
                              !dataDetail?.resi || dataDetail?.resi === "-"
                            }
                          /> */}
                    </div>
                  </div>
                </div>
              </div>

              {/* total order */}
              <div className='flex justify-between items-center px-8'>
                <p className='p1-regular text-greyscaleGON-400'>Total Order</p>
                <p className='h6-medium text-successGON-400'>
                  {currency(dataDetail?.total_pembayaran)}
                </p>
              </div>
            </div>

            {/* History Orderan */}
            <div className='w-full flex flex-col gap-8 py-8 border border-greyscaleGON-200 rounded-2xl'>
              {/* History Orderan */}
              <p className='subheading-semiBold text-greyscaleGON-400 px-8'>
                History Order
              </p>
              <div className='flex flex-col gap-4 max-h-60 overflow-hidden overflow-y-scroll px-8'>
                {dataDetail?.history_transaction
                  ?.sort(
                    (a, b) => new Date(b?.created_at) - new Date(a?.created_at)
                  )
                  ?.map((item, index) => {
                    const dates = new Date(item?.created_at);
                    function isValidDate(dates) {
                      const now = new Date(); // Waktu saat ini
                      const fiveMinutes = 5 * 60 * 1000; // 5 menit dalam milidetik
                      const diff = now - dates; // Selisih waktu dalam milidetik

                      // Jika selisih kurang dari 5 menit, kembalikan true, jika tidak false
                      return diff < fiveMinutes;
                    }

                    const isValidNew = isValidDate(dates);

                    const milliseconds = dates.getTime();
                    let isDates = formatDistanceToNow(milliseconds, {
                      addSuffix: true,
                      locale: id,
                    });

                    return (
                      <div
                        key={index}
                        className='flex w-fit justify-start flex-col gap-2'>
                        <div className='flex w-full items-center justify-between gap-2'>
                          <Label
                            title={!item?.created_at ? "-" : isDates}
                            className={"w-fit"}
                            size='small'
                          />
                          {isValidNew && (
                            <Label
                              title={"Baru"}
                              className={"w-fit"}
                              colors='success'
                              size='small'
                            />
                          )}
                        </div>
                        <div className='flex flex-row gap-1'>
                          <p className='p2-regular text-greyscaleGON-700'>
                            {item?.note}
                          </p>
                        </div>
                      </div>
                    );
                  })}
              </div>
              <Divider />

              <div className='flex flex-col gap-8  px-8'>
                {/* Status Order */}
                <p className='subheading-semiBold text-greyscaleGON-400'>
                  Status Order
                </p>
                <div className='flex flex-col gap-2'>
                  {dataDetail?.history_status_date?.map((item, index) => {
                    let date = new Date(item?.status_date);
                    date = !isNaN(date) ? date : new Date();
                    const formattedDate = format(date, "yyyy-MM-dd");
                    const time = format(date, "pp");

                    return (
                      <div
                        key={index}
                        className='flex items-center gap-5'>
                        <p>{formattedDate}</p>
                        <p>{time}</p>
                        <Label
                          classNameText={"uppercase"}
                          title={title?.[item?.status]}
                          colors={colors?.[item?.status]}
                          univColor
                          size='small'
                        />
                      </div>
                    );
                  })}
                </div>
                <Divider />

                {/* Catatan */}
                <p className='subheading-semiBold text-greyscaleGON-400'>
                  Catatan
                </p>
                <div className='bg-greyscaleGON-50 p-4'>
                  <p>{dataDetail?.catatan ?? "-"}</p>
                </div>
                <Divider />

                {/* Dropship */}
                <p className='subheading-semiBold text-greyscaleGON-400'>
                  Dropship
                </p>
                <div className='flex flex-col gap-1'>
                  <p className='p1-semiBold text-greyscaleGON-700 capitalize'>
                    {dataDetail?.addres_drops?.sander_name}
                  </p>
                  <p className='p1-regular text-greyscaleGON-700'>
                    {dataDetail?.addres_drops?.sander_telephon}
                  </p>
                </div>
                <Divider />

                {/* Alamat Penerima */}
                <p className='subheading-semiBold text-greyscaleGON-400'>
                  Alamat Penerima
                </p>
                <div className='flex flex-col gap-1'>
                  <p className='p1-semiBold text-greyscaleGON-700 capitalize'>
                    {dataDetail?.addres_recipient?.recipient_name}
                  </p>
                  {dataDetail?.addres_recipient?.address == "-" ? null : (
                    <p className='p1-regular text-greyscaleGON-700'>
                      {dataDetail?.addres_recipient?.address}, Kel.{" "}
                      {dataDetail?.addres_recipient?.subdistrict_name}, Kec.{" "}
                      {dataDetail?.addres_recipient?.district_name},{" "}
                      {dataDetail?.addres_recipient?.city_name},{" "}
                      {dataDetail?.addres_recipient?.province_name}{" "}
                      {dataDetail?.addres_recipient?.postal_code}
                    </p>
                  )}
                  <p className='p1-regular text-greyscaleGON-700'>
                    {dataDetail?.addres_recipient?.recipient_telephon}
                  </p>
                </div>
                <Divider />

                {/* No Resi */}
                <p className='subheading-semiBold text-greyscaleGON-400'>
                  No Resi
                </p>
                <div className='flex flex-col gap-1'>
                  <p className='p1-semiBold text-greyscaleGON-700 capitalize'>
                    -{" "}
                    {!dataDetail?.resi || dataDetail?.resi == "-"
                      ? dataDetail?.resi_marketplace
                      : dataDetail?.resi}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ContainerModal>
    </div>
  );
}
